export default __webpack_public_path__ + "static/media/Finger-Rings.0635b985.jpg";